module.exports = __webpack_public_path__ + "fonts/Lato-400-latin-ext1.46e5ea9.woff2";